import React from 'react';
import styled from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockCardGrid, StackedGrid } from '../../blocks/BlockCardGrid';
import { BlockInfo } from '../../blocks/BlockInfo';
import { Body } from '../../components/Base';
import { CardBlockLayoutProps } from './CardLayout';

export const CardBlockLayoutLongText = (props: CardBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);
  const bodyMaxColumns = props.blocks[0]?.bodyMaxColumns ?? props.blockBodyMaxColumns;

  return (
    <StyledBlockLayout {...props} bodyMaxColumns={bodyMaxColumns}>
      <StyledBlockInfo {...innerProps} block={props.blocks[0]} />
      <StyledBlockCardGrid {...innerProps} block={props.blocks[0]} />
    </StyledBlockLayout>
  );
};

const FallbackMaxColumns = 1;

const StyledBlockCardGrid = styled(BlockCardGrid)``;
const StyledBlockInfo = styled(BlockInfo)``;

const StyledBlockLayout = styled(BlockLayout)<{ bodyMaxColumns?: number }>`
  ${StyledBlockCardGrid} {
    position: relative;
    z-index: 1;

    background-color: transparent;

    ${StackedGrid} {
      padding: 0 var(--unit-length) var(--unit-length);
    }
  }

  ${StyledBlockInfo} {
    min-height: ${(props) => {
      switch (props.height) {
        case 'medium':
          return '60vh';
        case 'large':
          return '80vh';
        default:
          return undefined;
      }
    }};

    ${Body} {
      column-count: ${(props) => props.bodyMaxColumns ?? FallbackMaxColumns};
      column-width: max(calc(var(--unit-length) * 7), 300px);
      column-gap: var(--unit-length);
      width: 100%;
    }
  }
`;
